// extracted by mini-css-extract-plugin
export default {"s_label":"detailsTableLabel_s_label__n0YqC","s_optional":"detailsTableLabel_s_optional__EmyLD","s_header":"detailsTableLabel_s_header__BqF-q"};